import { useRef, useCallback } from 'react'
import { CONFIG } from '../config'

const TOKEN_SPLIT = new RegExp(`(${CONFIG.token.pattern.source})`, 'g')

export function HighlightedTextarea({ value, className, style, ...props }) {
  const backdropRef = useRef(null)
  const textareaRef = useRef(null)

  const syncScroll = useCallback(() => {
    if (backdropRef.current && textareaRef.current) {
      backdropRef.current.scrollTop = textareaRef.current.scrollTop
      backdropRef.current.scrollLeft = textareaRef.current.scrollLeft
    }
  }, [])

  return (
    <div className="relative bg-white dark:bg-neutral-800 rounded-lg">
      <div
        ref={backdropRef}
        className="absolute inset-0 p-4 font-mono text-sm whitespace-pre-wrap break-words overflow-hidden pointer-events-none border border-transparent rounded-lg select-none z-[1]"
        style={{ ...style, color: 'transparent' }}
        aria-hidden="true"
      >
        {value
          ? value.split(TOKEN_SPLIT).map((part, i) =>
              i % 2 === 1 ? (
                <span
                  key={i}
                  className="bg-blue-200 dark:bg-blue-500/30 rounded-sm"
                >
                  {part}
                </span>
              ) : (
                part
              )
            )
          : null}
        {'\n'}
      </div>
      <textarea
        ref={textareaRef}
        value={value}
        onScroll={syncScroll}
        className={className}
        style={{ ...style, background: 'transparent', position: 'relative', zIndex: 2 }}
        {...props}
      />
    </div>
  )
}
